import { getPilotValue } from './pilots';
import { getProduct } from './product';
import { Products } from './constants';

export const getIsUnifiedProduct = (serverContext) => {
  const product = getProduct(serverContext);

  return product === Products.UP;
};

export const getIsDMC = (serverContext) => {
  const product = getProduct(serverContext);

  return product === Products.DMC;
};

// This function is for signup, because in signup flow we allow user to switch to expert mode
// Then a expert account will be created
export const getIsUnifiedProductOrExpert = (serverContext) => {
  const product = getProduct(serverContext);

  if (product === Products.Unknown) {
    return getPilotValue(serverContext, 'isUPSignupEnabled');
  }

  return product === Products.UP || product === Products.Expert;
};
